"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fragments = exports.fragmentName = void 0;
var fragmentName = 'bookingArrangementFields';
exports.fragmentName = fragmentName;
var fragment = "\nfragment ".concat(fragmentName, " on BookingArrangement {\n    bookingMethods\n    bookingNote\n    minimumBookingPeriod\n    bookingContact {\n        phone\n        url\n    }\n}\n");
var fragments = [fragment];
exports.fragments = fragments;